import React, { lazy } from 'react';
import ModalProvider from '../providers/modal.provider.js';
import FeatureFlagsSetting from '../pages/settings/FeatureFlagsSetting/FeatureFlagsSetting.jsx';
import { withFeatureFlag } from '../hooks/Helper.js';
import TranslationsPlugin from '../pages/settings/TranslationsPlugin.jsx';
const Users = lazy(() => import('../pages/settings/users'));
const Statuses = lazy(() => import('../pages/settings/statuses'));
const Company = lazy(() => import('../pages/settings/company'));
const SalesTax = lazy(() => import('../pages/settings/salesTax'));
const Currency = lazy(() => import('../pages/settings/currency'));
const Countries = lazy(() => import('../pages/settings/countries'));
const Regions = lazy(() => import('../pages/settings/regions'));
const OldPayments = lazy(() => import('../pages/settings/payments.js'));
const NewPayments = lazy(() => import('../pages/settings/Payments.jsx'));
const Payments = withFeatureFlag({
  flagKey: 'PAYMENTS_METHOD',
  EnabledComponent: NewPayments,
  DisabledComponent: OldPayments,
});
// const Payments = lazy(() => import('../pages/settings/Payments.jsx'));
const RegionDetail = lazy(() => import('../pages/settings/regionDetail'));
const Theme = lazy(() => import('../pages/settings/theme'));
const Navigation = lazy(() => import('../pages/settings/navigation'));
const CustomerDetailSettings = lazy(
  () => import('../pages/settings/pageSettings/customerDetailSettings')
);
const TreeSettings = lazy(() => import('../pages/settings/pageSettings/treeSettings'));
const DashboardSettings = lazy(() => import('../pages/settings/dashboard'));
const WidgetSettings = lazy(() => import('../pages/settings/widgets'));
const EditWidget = lazy(() => import('../pages/settings/editWidget'));
const PlacementRules = lazy(() => import('../pages/settings/placementRules'));
const EmailContent = lazy(() => import('../pages/settings/emailContent'));
const EmailSettings = lazy(() => import('../pages/settings/emailSettings'));
const ForexSettings = lazy(() => import('../pages/settings/forex'));
const StatusByEvent = lazy(() => import('../pages/settings/statusByEvent'));
const Pages = lazy(() => import('../pages/settings/page'));

const routes = [
  {
    path: 'users',
    element: <Users />,
  },
  {
    path: 'theme',
    element: <Theme />,
  },
  {
    path: 'navigation',
    element: <Navigation />,
  },
  {
    path: 'pages',
    element: <Pages />,
  },
  {
    path: 'pages/:pageId',
    element: (
      <ModalProvider>
        <CustomerDetailSettings />
      </ModalProvider>
    ),
  },
  {
    path: 'pages/tree/:treeId',
    element: <TreeSettings />,
  },
  {
    path: 'dashboard',
    element: <DashboardSettings />,
  },
  {
    path: 'widgets',
    element: <WidgetSettings />,
  },
  {
    path: 'widgets/:widgetId',
    element: (
      <ModalProvider>
        <EditWidget />
      </ModalProvider>
    ),
  },
  {
    path: 'pages/:pageId/widgets/:widgetId',
    element: (
      <ModalProvider>
        <EditWidget />
      </ModalProvider>
    ),
  },
  {
    path: 'payments',
    element: <Payments />,
  },
  {
    path: 'regions',
    element: <Regions />,
  },
  {
    path: 'regions/:regionId',
    element: <RegionDetail />,
  },
  {
    path: 'countries',
    element: <Countries />,
  },
  {
    path: 'currency',
    element: <Currency />,
  },
  {
    path: 'salestax',
    element: <SalesTax />,
  },
  {
    path: 'statuses',
    element: <Statuses />,
  },
  {
    path: 'statuses/:statusID',
    element: <StatusByEvent />,
  },
  {
    path: 'company',
    element: <Company />,
  },
  {
    path: 'trees',
    element: <PlacementRules />,
  },
  {
    path: 'email/content',
    element: <EmailContent />,
  },
  {
    path: 'email/providers',
    element: <EmailSettings />,
  },
  {
    path: 'forex',
    element: <ForexSettings />,
  },
  {
    path: 'feature-flags',
    element: (
      <ModalProvider>
        <FeatureFlagsSetting />
      </ModalProvider>
    ),
  },
  {
    path: 'translations',
    element: <TranslationsPlugin />,
  },
];

// const disabledRoutes = [
//     {
//         path: 'settings/business',
//         element: <BusinessSettings />
//     }
// ];

export default routes;
